import React from 'react';  
import { useLocation } from 'react-router-dom';  
import ChartComponent from '../components/Chart_Sensing'; // 追加  
import { useNavigate } from 'react-router-dom';  
import styled from 'styled-components';  

const Container = styled.div`  
    padding: 0 20px 0 20px;  
`;  

const Button = styled.button`  
    width: 100%;  
    padding: 10px;  
    font-size: 16px;  
    background-color: green;  
    color: white;  
    border: none;  
    border-radius: 5px;  
    cursor: pointer;  
    align-self: center;  
`;  

const ChartPage = () => {  
    const location = useLocation();  
    const farmData = location.state?.farmData;  
    const greenhouseName = location.state?.greenhouseName;  
    const navigate = useNavigate();  

    const handleBack = () => {  
        try {  
            navigate(-1);  
        } catch (error) {  
            console.error('Error navigating back:', error);  
        }  
    }; 

    if (!farmData) {  
        return <div>データがありません。</div>;  
    }  
  
    return (  
        <div>   
            <Container>
                <h2>{greenhouseName} 1週間分の環境データ</h2>
                {/* <Button onClick={handleBack}>前の画面に戻る</Button>  */}
            </Container>
            
            <ChartComponent farmData={farmData} />  
            <Container>
                <Button onClick={handleBack}>前の画面に戻る</Button> 
            </Container>
        </div>  
    );  
};  

export default ChartPage;  
